import React, { useEffect, useState } from "react";
import Navbarsticky from "./NavbarSticky";
import Footer from "./Footer";
import { Container, Row, Col, Card, Image } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { getWaterSports } from "../store/slices/watersports";
import "../watersports.css";
import { Link } from "react-router-dom";
import { OverlayTrigger, Popover } from "react-bootstrap";

const WaterSportSkeleton = () => {
  return (
    <Card className="tour-card shadow-sm h-100">
      <div className="tour-img-wrapper skeleton-img"></div>

      <Card.Body>
        <div className="skeleton skeleton-title mb-2"></div>
        <div className="skeleton skeleton-text mb-2"></div>
        <div className="skeleton skeleton-text short"></div>
      </Card.Body>
    </Card>
  );
};

export default function WaterSports() {
  const dispatch = useDispatch();

  const [activities, setActivities] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchActivities = () => {
    setLoading(true);
    dispatch(getWaterSports())
      .unwrap()
      .then((data) => {
        setActivities(data?.waterSports?.WaterSportsData || []);
      })
      .catch((err) => console.error(err))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    fetchActivities();
  }, []);

  return (
    <>
      <Navbarsticky />

      {/* HERO SECTION */}
      <section className="watersports-hero">
        <div className="hero-overlay">
          <h1>Discover Water Adventures</h1>
          <p>Experience thrill, waves & unforgettable memories</p>
        </div>
      </section>

      {/* ACTIVITIES */}
      <Container className="activities-section py-5">
        <Row className="g-4">
          {loading
            ? Array.from({ length: 6 }).map((_, idx) => (
                <Col key={idx} xs={12} sm={6} md={2} lg={4}>
                  <WaterSportSkeleton />
                </Col>
              ))
            : activities.map((item, idx) => (
                <Col key={idx} xs={12} sm={6} md={2} lg={4}>
                  <Link
                    to={`/watersport-details/${item._id}`}
                    className="text-decoration-none text-dark"
                  >
                    <Card className="tour-card shadow-sm h-100">
                      <div className="tour-img-wrapper">
                        <img
                          src={item?.image?.[0]?.mediaLink}
                          alt={item.name}
                          className="tour-img"
                        />
                      </div>

                      <Card.Body>
                        <Card.Title className="tour-title">
                          {item.name}
                        </Card.Title>

                        {/* LOCATION POPOVER */}
                        {(() => {
                          const pop = (
                            <Popover
                              id="place-popover"
                              style={{
                                maxWidth: "260px",
                                borderRadius: "12px",
                              }}
                            >
                              <Popover.Body>
                                <div className="fw-bold mb-2">
                                  Available Locations
                                </div>
                                <ul className="list-unstyled mb-0 ps-2">
                                  {item.place?.map((p, i) => (
                                    <li key={i} className="text-muted">
                                      📍 {p.placeName}
                                    </li>
                                  ))}
                                </ul>
                              </Popover.Body>
                            </Popover>
                          );

                          const places =
                            item.place?.map((p) => p.placeName) || [];
                          const firstTwo = places.slice(0, 2).join(", ");
                          const more =
                            places.length > 2
                              ? ` + ${places.length - 2} more`
                              : "";

                          return (
                            <OverlayTrigger
                              placement="bottom"
                              trigger={["hover", "focus"]}
                              overlay={pop}
                            >
                              <Card.Text className="tour-location">
                                <i className="bi bi-geo-alt-fill me-1"></i>
                                {firstTwo}
                                {more}
                              </Card.Text>
                            </OverlayTrigger>
                          );
                        })()}

                        <Card.Text className="tour-meta">
                          <i className="bi bi-clock me-1"></i>
                          {item.duration || "30–60 mins"}
                        </Card.Text>
                      </Card.Body>
                    </Card>
                  </Link>
                </Col>
              ))}
        </Row>
      </Container>

      <Footer />
    </>
  );
}
